import { render } from "./OrderStatusDetails.vue?vue&type=template&id=873ace76&ts=true"
import script from "./OrderStatusDetails.ts?vue&type=script&lang=ts"
export * from "./OrderStatusDetails.ts?vue&type=script&lang=ts"

import "./OrderStatusDetails.vue?vue&type=style&index=0&id=873ace76&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__